import { PrivateInterceptor } from "../../../Base/interceptors/PrivateInterceptor";

export const getEncabezadosIngresosQuimicosFechas = async(dates) =>{
    const result = await PrivateInterceptor(`Inventario/QuimicosYColorantes/IngresosQC/FechasEncabezado`, 'POST', {Fecha1 :dates[0], Fecha2: dates[1]})
    return result
}